// Post-auth flow.
//
// v1.7 (retired): resolved the OneDrive repo, looked up the token oid in
// users.json, and produced a LensUser. That model is gone in v2.0 — the
// Entra token itself is the identity, and the role comes from the token's
// `roles` claim. There is no repo, no users.json, no oid→folder map.
//
// This module now synthesizes the outcome directly from the AuthSession so
// existing App.tsx / LoginScreen code paths keep compiling and behaving as
// "signed-in" without needing OneDrive.
import type { AuthSession } from "./msal";
import type { LensUser } from "../fs/config";

export type SignInOutcome =
  | { status: "signed_in"; lensUser: LensUser; repoPath: string; previousLastLogin: string | null }
  | { status: "unknown_user" }
  | { status: "repo_missing"; reason: "cancelled" | "invalid" };

/**
 * v2.0: always resolves as signed_in. The token bearer is the identity.
 * `repoPath` is a placeholder (nothing reads from disk in v2.0); `lensUser`
 * is synthesized from the Entra profile.
 */
export async function completeSignIn(
  session: AuthSession,
  _interactive: boolean,
): Promise<SignInOutcome> {
  const lensUser: LensUser = {
    oid: session.user.oid,
    display_name: session.user.displayName,
    email: session.user.email,
    folder: session.user.oid, // legacy field; no longer a filesystem path
    is_admin: session.user.role === "admin",
    joined: new Date().toISOString(),
  };

  return {
    status: "signed_in",
    lensUser,
    repoPath: "cloud://lens", // sentinel; no filesystem is touched in v2.0
    previousLastLogin: null,
  };
}
